<div class="date-selector is-flex is-column gap-16">
  <div class="is-flex items-align-center">
    <app-radio-button-group size="small" >
      <app-radio-button-item (click)="selectUntilChanged()" [selected]="selectedIndex() === UNTIL_CHANGED_INDEX">
        <app-radio-button-label class="is-family-semiBold"
          [text]="'legrand-app.__LEG_END_DATE_UNDEFINED' | AsyncLang | async">
        </app-radio-button-label>
      </app-radio-button-item>

      <app-radio-button-item (click)="selectEndDate()" [selected]="selectedIndex() === END_TIME_INDEX">
        <app-radio-button-label class="is-family-semiBold"
          [text]="'legrand-app.__LEG_END_DATE' | AsyncLang | async">
        </app-radio-button-label>
      </app-radio-button-item>
    </app-radio-button-group>
  </div>
  <app-home-mode-control-date-selector *ngIf="selectedIndex() === END_TIME_INDEX" > </app-home-mode-control-date-selector>
</div>